module.exports = __webpack_public_path__ + "img/triangle-down.2b95fdf6.svg";